import { API } from "@/main.js";

const getDefaultState = () => {
  return {
    selectedTemplates: []
  };
};
const state = getDefaultState();

const getters = {};

const mutations = {
  selectedTemplates(state, n) {
    state.selectedTemplates = n;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  DELETE_TEMPLATES(state, template) {
    let index = state.selectedTemplates.findIndex(
      item => item.uuid == template.uuid
    );
    state.selectedTemplates.splice(index, 1);
  }
};
const actions = {
  resetselectedTemplateState({ commit }) {
    commit("resetState");
  },
  deleteTemplates({ commit }, template) {
    commit("DELETE_TEMPLATES", template);
  },

  sendTemplateData({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.workOrders.sendTemplateDataFilter(
        data,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchAllWorkOrders({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.workOrders.getAll(
        data.params,
        result => {
          resolve(result.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  createWorkOrder({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.workOrders.createWorkOrder(
        data,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  exportWorkOrder({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.workOrders.exportWorkOrder(
        data,
        result => {
          resolve(result.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  updateWorkOrder({ commit }, { data, uuid }) {
    return new Promise((resolve, reject) => {
      API.workOrders.updateWorkOrder(
        data,
        uuid,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  sendBulkActivities({ commit }, { activities, uuid }) {
    return new Promise((resolve, reject) => {
      API.workOrders.sendBulkActivities(
        activities,
        uuid,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  updateBulkActivities({ commit }, { activities, uuid }) {
    return new Promise((resolve, reject) => {
      API.workOrders.updateBulkActivities(
        activities,
        uuid,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getWorkOrderByUUID({ commit }, { uuid, params }) {
    return new Promise((resolve, reject) => {
      API.workOrders.getWorkOrderByUUID(
        uuid,
        params,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  deleteWorkOrderByUUID({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.workOrders.deleteWorkOrderByUUID(
        uuid,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  priorityLists({ commit }) {
    return new Promise((resolve, reject) => {
      API.workOrders.priorityList(
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  fetchWorkOrderActivities({ commit }, { uuid, params = null}) {
    return new Promise((resolve, reject) => {
      API.workOrders.getWorkOrderActivities(
        uuid,
        params,
        result => {
          resolve(result.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  fetchWorkOrderObjects({ commit }, { uuid, params = {}}) {
    return new Promise((resolve, reject) => {
      API.workOrders.getWorkOrderObjects(
        uuid,
        params,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/workOrders.js